var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FFC8C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8V10.06C21.89 10.92 24 13.6 24 16.77C24 19.94 21.89 22.61 19 23.47V25.54C23 24.63 26 21.05 26 16.77C26 12.49 23 8.91 19 8ZM21.5 16.77C21.5 15 20.5 13.48 19 12.74V20.77C20.5 20.06 21.5 18.53 21.5 16.77ZM8 13.77V19.77H12L17 24.77V8.77L12 13.77H8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.4f05f95ea4ae16248a3d9892a30c02cb.svg";
export { ForwardRef as ReactComponent };